$.fn.vSelect = function(settings) {
  // const elms = $(this);

  // elms.each(function() {
    const elm = $(this);
    const randomId = '-' + Math.floor(Math.random() * 1000) + '-' + Math.floor(Math.random() * 1000);
    let options = [];
    let selectedGroups = [];
    let selectedChilds = [];
    
    elm.hide();
  
    // Gather all labels and values into options array variable
    elm.find('optgroup').each(function(index) {
      gEl = $(this);
  
      const groupLabel = gEl.attr('label');
  
      options[groupLabel] = [];
  
      gEl.find('option').each(function(index) {
        const oEl = $(this);
  
        options[groupLabel].push({
          'label': oEl.text(),
          'value': oEl.attr('value'),
        })
      });
    });
  
    // Adding container div into html DOM
    const vSelectElm = $('<div></div>').insertAfter(elm);
    vSelectElm.addClass('vselect-container');
  
    // Append a div to display selected options
    vSelectElm.append('<div class="vselect-selected-display"><span class="vselect-placeholder">Please select</span></div>');

    const vSelectDisplay = vSelectElm.find('.vselect-selected-display');

    // Append options tray
    vSelectElm.append('<div class="vselect-tray-container hidden"><div class="vselect-tray"></div></div>');

    const vSelectTray = vSelectElm.find('.vselect-tray');

    // return;
  
    // Loop through options array to append checkboxs of each group and it's childs
    Object.keys(options).forEach(function(key, index) {
      const group = key;
      const groupIndex = index;
  
      // Append checkbox for a group
      vSelectTray.append('<div class="vselect-option group"><input type="checkbox" name="vselect-group-'+index+randomId+'" id="vselect-group-'+index+randomId+'" data-group-id="'+group+'"><label for="vselect-group-'+index+randomId+'">'+group+'</label></div>');
  
      childs = this[key];
  
      $.each(childs, function(index, value) {
        const child = value;
  
        // Append checkbox for a child
        vSelectTray.append('<div class="vselect-option child"><input type="checkbox" name="vselect-child-'+groupIndex+'-'+index+randomId+'" id="vselect-child-'+groupIndex+'-'+index+randomId+'" data-parent-id="'+group+'" data-label="'+child.label+'" value="'+child.value+'"><label for="vselect-child-'+groupIndex+'-'+index+randomId+'">'+child.label+'</label></div>');
      });
    }, options);
  
    const vSelectGroup = vSelectTray.find('.vselect-option.group input'); // Group checkbox elements
    const vSelectChild = vSelectTray.find('.vselect-option.child input'); // Child checkbox elements
  
    // When a child checkbox is checked or unchecked
    vSelectChild.on('change', function() {
      const el = $(this);
      const checked = el.is(":checked");
      const label = el.data('label');
      const value = el.val();
      const group = el.data('parent-id');
  
      // console.log('Child on change', label, value, group, checked);
  
      // Update relevant option in the original Select element
      elm.find('option[value="'+value+'"').prop("selected", checked);
  
      let isAllSiblingsChecked = true;
  
      // Check if all childs in the same group are checked
      vSelectTray.find('.vselect-option.child input[data-parent-id="'+group+'"]').each(function() {
        const cEl = $(this);
  
        if (!cEl.is(":checked")) {
          isAllSiblingsChecked = false;
  
          return;
        }
      });
  
      // Get parent (group) element
      const parent = vSelectTray.find('.vselect-option.group input[data-group-id="'+group+'"]');
  
      // Checked group checkbox if all childs are checked or otherwise
      if (isAllSiblingsChecked) {
        parent.prop("checked", true);
      } else {
        parent.prop("checked", false);
      }
  
      // Trigger original Select element's change event
      updateSelectElement(elm);
  
      updateSelectedChildsDisplay(label, checked);

      // Call back to onChange function
      settings.onChange({
        label,
        value,
        checked
      });
    });
  
    // When a group checkbox is checked or unchecked
    vSelectGroup.on('change', function() {
      // console.log('Group changed');
  
      const gEl = $(this);
      const group = gEl.data('group-id');
      const checked = gEl.is(":checked");
    
      vSelectTray.find('.vselect-option.child input[data-parent-id="'+group+'"]').each(function() {
        const cEl = $(this);
        const label = cEl.data('label');
        const value = cEl.val();
  
        cEl.prop("checked", checked);
        elm.find('option[value="'+value+'"').prop("selected", checked);

        tag = {
          'id': value,
          label,
          checked
        }
  
        // Call back to onChange function
        settings.onChange({
          label,
          value,
          checked
        });
        
        updateSelectedChildsDisplay(label, checked);
      });
  
      // Trigger original Select element's change event
      updateSelectElement(elm);
    });
  
    function updateSelectElement(elm) {
      elm.trigger('change');
    }
  
    function updateSelectedChildsDisplay(label, add) {
      isFound = selectedChilds.find((item, index) => {
        return item === label;
      });
      
      if (add) {
        if (isFound === undefined) {
          selectedChilds.push(label);
        }
      } else {
        selectedChilds = selectedChilds.filter((item, index) => {
          return item !== label;
        });
      }

      if (selectedChilds.length > 0) {
        selectedChilds.sort();
        vSelectDisplay.find('span').text(selectedChilds.join(', '));
      } else {
        vSelectDisplay.find('span').text('Please select');
      }
    }

    vSelectDisplay.on('click', function(){
      if ($(this).hasClass('vselect-tray-opened')) {
        $(this).removeClass('vselect-tray-opened');
        vSelectTray.parent().addClass('hidden');
      } else {
        $(this).addClass('vselect-tray-opened');
        vSelectTray.parent().removeClass('hidden');
      }
    });

    vSelectElm.updateOption = function(id, checked) {
      console.log('updateOption', id, checked);

      const el = vSelectTray.find('.vselect-option input[value='+id+']');

      el.prop("checked", checked);
      el.trigger('change');
    }

    vSelectElm.unselectAll = function() {
      let selectedChilds = [];
      
      vSelectTray.find('.vselect-option input').prop('checked', false);
      elm.find('option').prop("selected", false);
      vSelectDisplay.find('span').text('Please select');
      updateSelectElement(elm);
    }

    return vSelectElm;
  // });
  // elms.each END
}

// jQuery(function(){
  // $('.my-vselect').vSelect();

  // $('#select-countries').on('change', function() {
  //   console.log('#select-countries on change value', $(this).val());
  // });
// });
